import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Grid, Button, Typography } from '@material-ui/core';
import { HOURS_GRID, MINUTES_GRID } from '../../../utils/releveHeures';

const getFieldTitle = (field) => {
    switch (field) {
        case 'debut': return 'Heure de DÉBUT';
        case 'fin': return 'Heure de FIN';
        default: return "Sélectionner l'heure";
    }
};

// Modale de sélection d'heure (horloge à deux étapes : heures puis minutes)
export default function TimePickerDialog({ classes, timePicker, details, onClose, onSelectMode, onSelectHour, onSelectMinute }) {
    return (
        <Dialog
            open={timePicker.open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ style: { borderRadius: 16 } }}
        >
            <DialogTitle style={{ paddingBottom: 0 }}>{getFieldTitle(timePicker.field)}</DialogTitle>
            <DialogContent>
                <Box className={classes.clockDisplay}>
                    <span
                        className={`${classes.timeUnit} ${timePicker.mode === 'hours' ? classes.timeUnitActive : classes.timeUnitInactive}`}
                        onClick={() => onSelectMode('hours')}
                    >
                        {timePicker.h}
                    </span>
                    <span className={classes.timeUnit}>:</span>
                    <span
                        className={`${classes.timeUnit} ${timePicker.mode === 'minutes' ? classes.timeUnitActive : classes.timeUnitInactive}`}
                        onClick={() => onSelectMode('minutes')}
                    >
                        {timePicker.m}
                    </span>
                </Box>

                <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 12, textAlign: 'center' }}>
                    {timePicker.mode === 'hours' ? 'Choisissez les HEURES' : 'Choisissez les MINUTES'}
                </Typography>

                {timePicker.mode === 'hours' && (
                    <Grid container spacing={1}>
                        {HOURS_GRID.map(h => {
                            let isDisabled = false;
                            if (timePicker.field === 'fin' && details[timePicker.jour]?.debut) {
                                const [debutH] = details[timePicker.jour].debut.split(':').map(Number);
                                const hNum = Number(h);
                                if (hNum <= debutH && hNum >= 5) isDisabled = true;
                            }

                            return (
                                <Grid item xs={3} key={h}>
                                    <Button
                                        variant={timePicker.h === h ? 'contained' : 'outlined'}
                                        color={timePicker.h === h ? 'primary' : 'default'}
                                        disabled={isDisabled}
                                        className={classes.gridCellBtn}
                                        onClick={() => onSelectHour(h)}
                                    >
                                        {h}h
                                    </Button>
                                </Grid>
                            );
                        })}
                    </Grid>
                )}

                {timePicker.mode === 'minutes' && (
                    <Grid container spacing={1}>
                        {MINUTES_GRID.map(m => (
                            <Grid item xs={6} key={m}>
                                <Button
                                    variant={timePicker.m === m ? 'contained' : 'outlined'}
                                    color={timePicker.m === m ? 'primary' : 'default'}
                                    className={classes.gridCellBtn}
                                    onClick={() => onSelectMinute(m)}
                                >
                                    :{m}
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </DialogContent>
            <DialogActions style={{ padding: '16px 24px' }}>
                <Button onClick={onClose} color="default">
                    Annuler
                </Button>
            </DialogActions>
        </Dialog>
    );
}
